module.exports = "https://static.wanderu.com/static/media/mx.a1b8bb76.svg";